// Eshop plugin
export const PLUGIN_ESHOP = 'eshop'
export const PLUGIN_ESHOP_DELIVERY = 'eshop.delivery'
export const PLUGIN_ESHOP_INVOICE = 'eshop.invoice'
export const PLUGIN_ESHOP_PAYMENT = 'eshop.payment'
export const PLUGIN_ESHOP_PRICE_LISTS = 'eshop.price-lists'
export const PLUGIN_ESHOP_RATING = 'eshop.rating'
export const PLUGIN_ESHOP_STOCK = 'eshop.stock'
export const PLUGIN_ESHOP_SUBSCRIPTION = 'eshop.subscription'

export const PLUGIN_REMINDERS = 'reminders'

export const PLUGIN_BRANCHES = 'branches'

// Forms plugin
export const PLUGIN_FORMS = 'forms'

export const PLUGIN_NEEWSLETTER = 'newsletter'

// Auth plugins
export const PLUGIN_REGISTRATION = 'registration'
export const PLUGIN_AUTH_VIA_MICROSOFT = 'auth.via-microsoft'
export const PLUGIN_AUTH_VIA_GOOGLE = 'auth.via-google'
export const PLUGIN_AUTH_VIA_APPLE = 'auth.via-apple'

export type PluginRequirement = string | string[]

/**
 * Vyhodnotí požadavky na pluginy z meta stránky.
 * Pole na nejvyšší úrovni se vyhodnocuje jako AND, vnořené pole jako OR
 * (stačí alespoň jeden aktivní plugin ze skupiny).
 */
export const arePluginsSatisfied = (
  required: PluginRequirement[] | string | undefined,
  isActive: (plugin: string) => boolean
): boolean => {
  if (!required) return true
  if (typeof required === 'string') return isActive(required)
  if (!Array.isArray(required)) return false
  return required.every((group) =>
    Array.isArray(group) ? group.some((plugin) => isActive(plugin)) : isActive(group)
  )
}

export class ALL_PLUGINS {
  private static instance: ALL_PLUGINS
  private constructor() {}

  private plugins = {
    PLUGIN_BRANCHES,
    PLUGIN_ESHOP,
    PLUGIN_ESHOP_SUBSCRIPTION,
    PLUGIN_ESHOP_DELIVERY,
    PLUGIN_ESHOP_INVOICE,
    PLUGIN_ESHOP_PAYMENT,
    PLUGIN_ESHOP_PRICE_LISTS,
    PLUGIN_ESHOP_RATING,
    PLUGIN_ESHOP_STOCK,
    PLUGIN_FORMS,
    PLUGIN_NEEWSLETTER,
    PLUGIN_REGISTRATION,
    PLUGIN_AUTH_VIA_MICROSOFT,
    PLUGIN_AUTH_VIA_GOOGLE,
    PLUGIN_AUTH_VIA_APPLE,
  } as const

  private customPlugins = {}

  public static getInstance(): ALL_PLUGINS {
    if (!ALL_PLUGINS.instance) {
      ALL_PLUGINS.instance = new ALL_PLUGINS()
    }
    return ALL_PLUGINS.instance
  }

  public extendPlugins(myPlugins: { [key: string]: string }) {
    this.customPlugins = myPlugins
  }

  public getPlugins() {
    return { ...this.plugins, ...this.customPlugins }
  }
}
